import { useForm } from 'react-hook-form';
import { PrimaryButton, SnackbarStatus, Typography, useSnackbar } from '@weareopenr/component-library';
import { useNavigate } from 'react-router-dom';
import VenueFormDetails from 'src/components/VenueFormDetails';
import { createVenueForm } from './utilities';
import { IVenueCreateFormValues } from './types';
import { initialAddressValues } from 'src/helpers/venueFormUtilities/constants';
import styles from './VenueCreateForm.module.scss';
import { useUserTracking } from 'src/hooks/useUserTracking/useUserTracking';

const VenueCreateForm = () => {
  const { showSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const { trackEvent, captureException } = useUserTracking();

  const formFields = useForm<IVenueCreateFormValues>({
    defaultValues: {
      name: '',
      isTrial: false,
      addresses: [initialAddressValues],
      channels: null,
    },
    mode: 'onChange',
  });

  const {
    handleSubmit,
    formState: { isSubmitting },
  } = formFields;

  const onSubmit = async (data: IVenueCreateFormValues) => {
    try {
      const venue = await createVenueForm(data);
      trackEvent('venue_created', { venueId: venue.venueId, venueName: data.name });
      showSnackbar({
        status: SnackbarStatus.SUCCESS,
        message: `You have successfully created ${data.name} venue.`,
      });

      navigate(`/venues/${venue.venueId}`);
    } catch (e) {
      captureException(e, { tags: { action: 'create_venue', venueName: data.name } });
      showSnackbar({
        status: SnackbarStatus.ERROR,
        message: 'Something went wrong whilst creating a venue.',
      });
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} id="venue-form" aria-label="venue-form">
      <Typography size="xlarge" weight="bold" className={styles['form-heading']}>
        Create Venue
      </Typography>
      <div className={styles['venue-form']}>
        <VenueFormDetails formFields={formFields} />
      </div>
      <div>
        <PrimaryButton type="submit" size="full-width" loading={isSubmitting}>
          Create
        </PrimaryButton>
      </div>
    </form>
  );
};

export default VenueCreateForm;
